import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Amplify } from "aws-amplify";
import { downloadData, getUrl, uploadData } from "aws-amplify/storage";
import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import { createRobotData, getRefData, getRobotData } from "../api/robotData";
import { getTeams } from "../api/teams";
import { TOAST_SETTINGS } from "../config/constants";
import useToastContext from "../config/useToastContext";
import { useGlobal } from "../context/GlobalProvider";

function GetSignedUrl({ url, team_number }) {
  const [signed, setSigned] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const getUrlResult = await getUrl({
        path: ({ identityId }) => `public/${team_number}/${url}`,
      });
      setSigned(getUrlResult.url);
    };
    fetchData();
  }, []);

  return (
    <>
      <img
        height={"100%"}
        width={"100%"}
        src={signed}
        onClick={() => setOpen(true)}
      />
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "70%", md: "60", lg: "50%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            aspectRatio: 1,
            textAlign: "center",
          }}
        >
          <img height={"100%"} width={"100%"} src={signed} />
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </>
  );
}

function GetBaseImage({ image }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <img
        height={"100%"}
        width={"100%"}
        src={image}
        onClick={() => setOpen(true)}
      />
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "70%", md: "60", lg: "50%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            aspectRatio: 1,
            textAlign: "center",
          }}
        >
          <img height={"100%"} width={"100%"} src={image} />
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </>
  );
}

async function GetRefData() {
  try {
    // Fetch all matches if no filter is set
    const data = await getRefData();
    if (!data?.body) throw new Error("Invalid API response");
    return data;
  } catch (error) {
    console.error("Error fetching matches:", error);
    return { body: JSON.stringify({ data: [] }) };
  }
}

async function fetchAndUploadFile(originalFileKey, newFileKey) {
  try {
    // Step 1: Download the file
    const downloadResponse = await downloadData({ path: originalFileKey });
    const response = await downloadResponse.result; // Await the result promise

    if (!response || !response.body) {
      console.error("Download failed: No response body");
      return;
    }

    // Step 2: Convert response body to Blob
    const fileBlob = await response.body.blob();

    // Step 3: Upload the file
    const uploadResult = await uploadData({
      path: newFileKey,
      data: fileBlob,
      options: {
        contentType: fileBlob.type, // Preserve original MIME type
      },
    });

    return uploadResult;
  } catch (error) {
    console.error("Error processing file:", error);
  }
}

async function GetTeams() {
  const data = await getTeams();
  return data;
}

async function GetRobotData(teamNumber) {
  const data = await getRobotData(teamNumber);
  const parsed = JSON.parse(data?.body);
  console.log(parsed);
  return parsed;
}

const authConfig = {
  Cognito: {
    userPoolId: "us-west-1_MRRH7QyfO",
    userPoolClientId: "5qt0r318huub5gh0186csj59ui",
    identityPoolId: "us-west-1:24322939-b437-43d1-b846-8998c0d8f199",
  },
};

Amplify.configure({
  Storage: {
    S3: {
      region: "us-west-1",
      bucket: "igniteinsightsbucketb2c1b-dev",
    },
  },
  Auth: authConfig,
  API: {
    REST: {
      igniteinsights: {
        endpoint: "https://j5dk657cyb.execute-api.us-west-1.amazonaws.com/dev",
        region: "us-west-1",
      },
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Home({ user, signOut }) {
  const [open, setOpen] = useState(false);
  const [facingMode, setFacingMode] = useState("user"); // Default: front camera
  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [images, setImages] = useState([]);
  const [refData, setRefData] = useState([]);
  const [value, setValue] = useState({});
  const [teamList, setTeamList] = useState([]);
  const addToast = useToastContext();
  const { setCurrentTab } = useGlobal();

  useEffect(() => {
    setCurrentTab("scouting");
    const fetchData = async () => {
      const result = await GetRefData();
      const data = JSON.parse(result?.body) ?? [];
      const teamResult = await GetTeams();
      const teamData = JSON.parse(teamResult?.body) ?? [];
      setTeamList(teamData?.data);
      setRefData(data.data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (value["team_number"]) {
        const result = await GetRobotData(Number(value["team_number"]));
        if (result?.data.length > 0) {
          let temp = result.data[0];
          let foundData = {
            gear_ratios: temp?.gear_ratios,
            team_number: value["team_number"],
            team_name: value["team_name"],
            intake_type: temp.intake_type,
            drivebase: temp?.drivebase,
            drive_motors: temp?.drive_motors,
            steer_motors: temp?.steer_motors,
            coral_placing_mechanic: temp?.coral_placing_mechanic,
            coral_intake_mechanic: temp?.coral_intake_mechanic,
            algae_intake_mechanic: temp?.algae_intake_mechanic,
            algae_placing_mechanic: temp?.algae_placing_mechanic,
            auto_count: temp?.auto_count,
            weight: temp?.weight,
            cage_height: temp?.cage_height,
            store_multiple_pieces: [
              temp?.store_multiple_pieces === 1 ? "Yes" : "No",
            ],
          };

          setImages(temp?.images);
          setValue(foundData);
        } else {
          let foundData = {
            team_number: value["team_number"],
            team_name: value["team_name"],
          };
          setValue(foundData);
        }
      } else {
        let foundData = {
          team_number: value["team_number"],
          team_name: value["team_name"],
        };
        setValue(foundData);
      }
    };

    fetchData();
  }, [value["team_number"]]);

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setCapturedImage(null);
    setOpen(false);
  };

  const base64ToFile = (base64String, fileName) => {
    const base64Data = base64String.replace(/^data:image\/\w+;base64,/, ""); // Remove base64 prefix
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512);
      const byteNumbers = new Array(slice.length);

      for (let j = 0; j < slice.length; j++) {
        byteNumbers[j] = slice.charCodeAt(j);
      }

      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new File(byteArrays, fileName, { type: "image/jpeg" });
  };

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      setImages((prev) => [...prev, imageSrc]);
    }
    handleClose();
  };

  const flipCamera = () => {
    setFacingMode((prevMode) => (prevMode === "user" ? "environment" : "user"));
  };

  const handleImageDelete = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const videoConstraints = {
    facingMode: facingMode,
    width: 720,
    height: 720,
  };

  const handleStringChange = (name, event) => {
    let value = event?.target?.value ?? "";
    setValue((prev) => ({ ...prev, [name]: value }));
  };

  const handleNumberChange = (name, event) => {
    let value = event?.target?.value ?? "";
    setValue((prev) => ({ ...prev, [name]: Number(value) }));
  };

  const handleSelectChange = (event, name) => {
    const {
      target: { value },
    } = event;
    setValue((prev) => ({
      ...prev,
      [name]: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const handleTeamChange = (e, value) => {
    const team_number = value?.team_number || "";
    const team_name = value?.team_name || "";
    setValue((prev) => ({
      ...prev,
      team_number: team_number,
      team_name: team_name,
    }));
  };

  const reqProps = [
    { prop: "team_number", emptyValue: 0, commonName: "Team Number" },
    { prop: "team_name", emptyValue: "", commonName: "Team Name" },
    { prop: "drivebase", emptyValue: 0, commonName: "Drivebase" },
    { prop: "intake_type", emptyValue: 0, commonName: "Intake Type" },
    {
      prop: "coral_intake_mechanic",
      emptyValue: "",
      commonName: "Coral Intake Mechanic",
    },
    {
      prop: "coral_placing_mechanic",
      emptyValue: "",
      commonName: "Coral Placing Mechanic",
    },
    {
      prop: "algae_intake_mechanic",
      emptyValue: "",
      commonName: "Algae Intake Mechanic",
    },
    {
      prop: "algae_placing_mechanic",
      emptyValue: "",
      commonName: "Algae Placing Mechanic",
    },
    { prop: "cage_height", emptyValue: [], commonName: "Cage Height" },
    {
      prop: "store_multiple_pieces",
      emptyValue: 0,
      commonName: "Store Multiple Pieces",
    },
    { prop: "auto_count", emptyValue: 0, commonName: "Auto Count" },
    { prop: "weight", emptyValue: 0, commonName: "Weight" },
    { prop: "drive_motors", emptyValue: "0", commonName: "Drive Motors" },
    { prop: "gear_ratios", emptyValue: "", commonName: "Gear Ratios" },
    { prop: "steer_motors", emptyValue: [], commonName: "Steer Motors" },
  ];

  const handleSubmit = async () => {
    const missingProps = reqProps.filter(
      (p) => value[p.prop] === undefined || value[p.prop] === p.emptyValue
    );

    if (missingProps.length > 0) {
      addToast({
        message: `There was an error saving the match. ${missingProps
          .map((p) => p.commonName)
          .join(", ")}`,
        severity: TOAST_SETTINGS.severity.ERROR,
      });
    } else {
      let temp = { ...value };
      temp.store_multiple_pieces =
        value?.store_multiple_pieces?.length > 0
          ? value?.store_multiple_pieces[0] === "Yes"
            ? 1
            : 0
          : 0;
      temp.user_entered = user?.email;
      temp.user_id = user?.user_id;
      temp.team_number_entered = Number(user?.team_number);

      let index = 0;
      let fileNames = [];
      for (const image of images) {
        const file_name = `${value?.team_number}_${index}.jpg`;
        fileNames.push(file_name);

        const isBase64 = image.startsWith("data:image/");
        let file;
        if (!isBase64) {
          fetchAndUploadFile(
            `public/${Number(value?.team_number)}/${image}`,
            `public/${Number(value?.team_number)}/${file_name}`
          );
        } else {
          file = base64ToFile(image, file_name);
          await uploadData({
            path: `public/${Number(value?.team_number)}/${file_name}`,
            data: file,
          }).result;
        }

        index++;
      }

      temp.images = fileNames;

      const response = await createRobotData(temp);
      if (response.statusCode === 200) {
        addToast({
          message: "Successfully Recorded the robot data",
          severity: TOAST_SETTINGS.severity.SUCCESS,
        });
        let foundData = {
          team_number: "",
          team_name: "",
        };
        setValue(foundData);
        setImages([]);
      } else {
        addToast({
          message: "There was an error saving the match.",
          severity: TOAST_SETTINGS.severity.ERROR,
        });
      }
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography sx={{ fontSize: 30 }}>Pit Scouting</Typography>
      </Box>
      <Box>
        <Grid
          container
          sx={{ mt: 0.5, flexDirection: { xs: "column-reverse", sm: "row" } }}
          spacing={3}
        >
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3}>
              <Grid item xs={6} sx={{ px: 2 }}>
                <Autocomplete
                  value={value["team_number"]}
                  options={teamList}
                  getOptionKey={(option) => option.team_id}
                  getOptionLabel={(option) =>
                    `${option.team_name} (${option.team_number})`
                  }
                  filterOptions={(options, { inputValue }) => {
                    const filtered = options.filter(
                      (option) =>
                        option.team_name
                          .toLowerCase()
                          .includes(inputValue.toLowerCase()) ||
                        option.team_number
                          .toString()
                          .toLowerCase()
                          .includes(inputValue.toString().toLowerCase())
                    );
                    return filtered;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Team" />
                  )}
                  onChange={handleTeamChange}
                />
              </Grid>
              <Grid item xs={6} sx={{ px: 2 }}>
                <TextField
                  name="gear_ratios"
                  value={value?.gear_ratios || ""}
                  fullWidth
                  label="Gear Ratios"
                  variant="outlined"
                  type="string"
                  onChange={(e) => handleStringChange("gear_ratios", e)}
                  InputLabelProps={{
                    shrink: value?.gear_ratios ? true : false,
                  }}
                />
              </Grid>
              <Grid item xs={6} sx={{ px: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id="drivebase-label">Drive Base</InputLabel>
                  <Select
                    labelId="drivebase-label"
                    name="drivebase"
                    label="Drive Base"
                    value={value?.drivebase || ""}
                    onChange={(e) =>
                      setValue((prev) => ({
                        ...prev,
                        drivebase: e.target.value || null,
                      }))
                    }
                  >
                    {refData["ref_drive_base"]?.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{ px: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id="intake-type-label">Intake Type</InputLabel>
                  <Select
                    labelId="intake-type-label"
                    name="drivebase"
                    label="Intake Type"
                    value={value?.intake_type || ""}
                    onChange={(e) =>
                      setValue((prev) => ({
                        ...prev,
                        intake_type: e.target.value || null,
                      }))
                    }
                  >
                    {refData["ref_intake_type"]?.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{ px: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id="drive-motors-label">Drive Motors</InputLabel>
                  <Select
                    labelId="drive-motors-label"
                    name="drive_motors"
                    label="Drive Motors"
                    value={value.drive_motors || ""}
                    onChange={(e) =>
                      setValue((prev) => ({
                        ...prev,
                        drive_motors: e.target.value || null,
                      }))
                    }
                  >
                    {refData["ref_drive_motors"]?.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{ px: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id="drive-motors-label">Steer Motors</InputLabel>
                  <Select
                    labelId="steer_motors-label"
                    name="steer_motors"
                    label="Steer Motors"
                    value={value.steer_motors || ""}
                    onChange={(e) =>
                      setValue((prev) => ({
                        ...prev,
                        steer_motors: e.target.value || null,
                      }))
                    }
                  >
                    {refData["ref_steer_motors"]?.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ px: 2 }}>
            <Box
              sx={{
                borderColor: "#bada55",
                borderWidth: 2,
                borderStyle: "dashed",
                height: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Stack direction={"column"} sx={{ alignSelf: "center" }}>
                {images.length < 3 && (
                  <IconButton color="primary" onClick={handleOpen}>
                    <CameraAltIcon sx={{ fontSize: 60 }} />
                  </IconButton>
                )}
                {images.length > 0 && (
                  <ImageList
                    cols={3}
                    gap={8}
                    sx={{
                      ml: 2,
                      mr: 2,
                      overflow: "hidden",
                      height: {
                        xs: 100, // Smallest screens (phones)
                        sm: 110, // Small tablets
                        md: 125, // Medium screens
                        lg: 150, // Large screens
                      },
                    }}
                  >
                    {images.map((image, index) => {
                      // Check if the image is a Base64 (webcam) or a URL (AWS S3)
                      const isBase64 = image.startsWith("data:image/");
                      return (
                        <ImageListItem
                          key={index}
                          sx={{
                            borderColor: "#bada55",
                            borderWidth: 1,
                            borderStyle: "solid",
                            height: {
                              xs: 100, // Smallest screens (phones)
                              sm: 110, // Small tablets
                              md: 125, // Medium screens
                              lg: 150, // Large screens
                            },
                            width: {
                              xs: 100, // Smallest screens (phones)
                              sm: 110, // Small tablets
                              md: 125, // Medium screens
                              lg: 150, // Large screens
                            },
                            overflow: "hidden",
                          }}
                        >
                          {isBase64 ? (
                            <GetBaseImage image={image} />
                          ) : (
                            <GetSignedUrl
                              url={image}
                              team_number={value["team_number"]}
                            />
                          )}

                          <IconButton
                            onClick={() => handleImageDelete(index)}
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              backgroundColor: "rgba(255, 255, 255, 0.8)",
                              "&:hover": { backgroundColor: "white" },
                            }}
                          >
                            <DeleteIcon sx={{ color: "black" }} />
                          </IconButton>
                        </ImageListItem>
                      );
                    })}
                  </ImageList>
                )}
              </Stack>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={6} sm={3} sx={{ px: 2 }}>
            <TextField
              name="coral_placing_mechanic"
              fullWidth
              label="Coral Place Mechanic"
              variant="outlined"
              type="string"
              onChange={(e) => handleStringChange("coral_placing_mechanic", e)}
              value={value?.coral_placing_mechanic || ""}
              InputLabelProps={{
                shrink: value?.coral_placing_mechanic ? true : false,
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} sx={{ px: 2 }}>
            <TextField
              name="coral_intake_mechanic"
              fullWidth
              label="Coral Intake Mechanic"
              variant="outlined"
              type="string"
              onChange={(e) => handleStringChange("coral_intake_mechanic", e)}
              value={value?.coral_intake_mechanic || ""}
              InputLabelProps={{
                shrink: value?.coral_intake_mechanic ? true : false,
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} sx={{ px: 2 }}>
            <TextField
              name="algae_intake_mechanic"
              fullWidth
              label="Algae Intake Mechanic"
              variant="outlined"
              type="string"
              onChange={(e) => handleStringChange("algae_intake_mechanic", e)}
              value={value?.algae_intake_mechanic || ""}
              InputLabelProps={{
                shrink: value?.algae_intake_mechanic ? true : false,
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} sx={{ px: 2 }}>
            <TextField
              name="algae_placing_mechanic"
              fullWidth
              label="Algae Placing Mechanic"
              variant="outlined"
              type="string"
              onChange={(e) => handleStringChange("algae_placing_mechanic", e)}
              value={value?.algae_placing_mechanic || ""}
              InputLabelProps={{
                shrink: value?.algae_placing_mechanic ? true : false,
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} sx={{ px: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="cage-label">Cage Height</InputLabel>
              <Select
                labelId="cage-label"
                id="cage"
                multiple
                value={value["cage_height"] || []}
                onChange={(e) => handleSelectChange(e, "cage_height")}
                input={<OutlinedInput label="Cage Height" />}
                MenuProps={MenuProps}
              >
                <MenuItem key={1} value={"shallow"}>
                  Shallow
                </MenuItem>
                <MenuItem key={2} value={"deep"}>
                  Deep
                </MenuItem>
                <MenuItem key={3} value={"none"}>
                  None
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={3} sx={{ px: 2 }}>
            <TextField
              name="auto_count"
              fullWidth
              label="How many Autos"
              variant="outlined"
              type="number"
              onChange={(e) => handleNumberChange("auto_count", e)}
              value={value?.auto_count || ""}
              InputLabelProps={{
                shrink: value?.auto_count ? true : false,
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} sx={{ px: 2 }}>
            <TextField
              name="weight"
              fullWidth
              label="Weight (lbs)"
              variant="outlined"
              type="number"
              onChange={(e) => handleNumberChange("weight", e)}
              value={value?.weight || ""}
              InputLabelProps={{
                shrink: value?.weight ? true : false,
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} sx={{ px: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="multiple-label">Store Multiple Pieces</InputLabel>
              <Select
                labelId="multiple-label"
                id="multiple"
                value={value["store_multiple_pieces"] || []}
                onChange={(e) => handleSelectChange(e, "store_multiple_pieces")}
                input={<OutlinedInput label="Store Multiple Pieces" />}
                MenuProps={MenuProps}
              >
                <MenuItem key={1} value={"Yes"}>
                  Yes
                </MenuItem>
                <MenuItem key={2} value={"No"}>
                  No
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sx={{ px: 2 }}>
            <Button fullWidth variant="contained" onClick={handleSubmit}>
              S U B M I T
            </Button>
          </Grid>
        </Grid>
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            {!capturedImage ? (
              <>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  mirrored={facingMode === "user"}
                  width={350}
                />
                <Box mt={2} display="flex" justifyContent="center" gap={2}>
                  <Button variant="contained" onClick={capture}>
                    Capture
                  </Button>
                  <IconButton color="primary" onClick={flipCamera}>
                    <FlipCameraAndroidIcon />
                  </IconButton>
                </Box>
              </>
            ) : (
              <>
                <img src={capturedImage} alt="Captured" width={350} />
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ mt: 2 }}
                >
                  Close
                </Button>
              </>
            )}
          </Box>
        </Modal>
      </Box>
    </>
  );
}
